<script>
  import router from '../lib/router';
  import { onMount } from 'svelte';
  import { TS } from '../config/translation-keys.js';
  import { t9n } from '../lib/translate.js';
  import session from '../lib/session';
  import Events from '../lib/events.js';
  import APIClient from '../state-charts/api-client';
  import InputWithValidation from '../lib/components/InputField.svelte';
  import AddTeamDialog from './AddTeamDialog.svelte';
  import TeamDetailsDialog from './TeamDetailsDialog.svelte';

  // component options  ------------------------------------------------------ //

  export let route_name;

  // translated strings ------------------------------------------------------ //

  let add_team_title = t9n(TS.ORDERER_TEAMS_ADD_TEAM_TITLE);
  let team_name_title = t9n(TS.ORDERER_TEAMS_TEAM_NAME_TITLE);
  let team_code_title = t9n(TS.ORDERER_TEAMS_TEAM_CODE_TITLE);
  let explanation = t9n(TS.ORDERER_TEAMS_EXPLANATION);
  let search_placeholder = t9n(TS.ORDERER_TEAMS_SEARCH_PLACEHOLDER);
  let desc = t9n(TS.ORDERER_TEAMS_EXPLANATION);
  let button_add;

  // internal variables ------------------------------------------------------ //

  let user;
  let teams = [];
  let all_teams;

  let query = '';
  let search_field;

  let add_team_dialog;
  let edit_team_dialog;
  let is_api_running = false;

  // utility functions -------------------------------------------------------- //

  const get_teams = async () => {
    if(!is_api_running){
      is_api_running = true;
      // let team_length = teams.length;
      // let data;
      //
      // while (!!data) {
      //   data = await APIClient.get_orderer_teams();
      //   console.log('case1')
      //   teams = data.teams;
      //   all_teams = teams;
      // }


      let data;
      let retryCount = 0;
      const maxRetries = 5; // Maximum number of retries
      const delayBetweenRetries = 1000; // 1 second delay between retries

      while (!data && retryCount < maxRetries) {
        try {
          data = await APIClient.get_orderer_teams();
          if (!data) {
            console.log('No data received. Retrying...');
            await new Promise(resolve => setTimeout(resolve, delayBetweenRetries)); // Wait before retrying
            retryCount++;
          }
        } catch (error) {
          console.error('Error occurred while fetching data:', error);
          break; // Exit loop on error
        }
      }

      if (data) {
        console.log('Data received:', data);
        teams = data.teams;
        all_teams = teams;
      } else {
        console.log('Max retries reached. Unable to fetch data.');
      }


      // console.log('data', data);
      // if(!!data){
      //
      // } else {
      //   // console.log('case2')
      //   // if(team_length > 0){
      //   //   teams = [];
      //   //   all_teams = [];
      //   // }
      // }
      is_api_running = false;
    }


  };

  const open_add_team_dialog = e => {
    let target = document.querySelector('#add-team');
    target.innerHTML = '';
    return new AddTeamDialog({
      target: target,
      props: { user: user },
    });
  };

  const open_edit_team_dialog = team_id => {
    let team = teams.find(t => t.team_id === team_id);
    let target = document.querySelector('#edit-team');
    target.innerHTML = '';
    return new TeamDetailsDialog({
      target: target,
      props: { team: team },
    });
  };

  const filter_teams = () => {
    if (!!query) {
      let searchterm = query.toLowerCase();
      teams = all_teams.filter(t => t.name.toLowerCase().includes(searchterm));
    } else {
      teams = all_teams;
    }
  };

  const init_teams = async () => {
    document.querySelector('.mdc-top-app-bar--fixed-adjust').scrollIntoView({behavior: "smooth"})
    if ($session.user.last_role !== 'orderer') router.navigate('/home');

    await get_teams();
    window.addEventListener('ordererteamdeleted', async () => { console.log('delete'); await get_teams()});
    window.addEventListener('ordererteamadded', async () => { console.log('add'); await get_teams()});
    user = $session.user;
  };

  onMount(async () => await init_teams());

  // reactive functions ------------------------------------------------------- //
</script>

  <main class="main--global wrapper fade-in">
    <!-- Search box -->
    <div style="display: flex; justify-content: space-between">
      <InputWithValidation
        leading_icon="search"
        id="search-field"
        data_cy="search-field"
        type="text"
        margin_bottom={'0px'}
        label={search_placeholder}
        name="search-field"
        bind:value={query}
        on:keyup={filter_teams} />
      <button
        on:click={open_add_team_dialog}
        style="margin-left: 10px; align-self: center"
        class="mdc-button mdc-button--oval mdc-button--raised">
        <span class="mdc-button__ripple" />
        {add_team_title}
      </button>
    </div>

    <!-- Help line -->
    <div
      id="help-liner"
      class="fade-in-long"
      style="margin-top: 10px; margin-bottom: 10px">
      <div class="tooltip-default">
        <div
          id="tooltip_def"
          class="tooltip-text tooltip-top"
          style="background-color:var(--mdc-theme-secondary); color: rgb(255,
          255, 255);">
          {desc}
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="mdc-data-table table-min-height" style="margin-bottom: 20px">
      <table id="teams_table" class="mdc-data-table__table table fitscreen">

        <thead>
          <tr
            class="mdc-data-table__header-row mdc-data-table-bold fade-in"
            style="height: 46px">
            <th class="mdc-data-table__header-cell fade-in">
              {team_name_title}
            </th>
            <th class="mdc-data-table__header-cell fade-in">
              {team_code_title}
            </th>
          </tr>
        </thead>
        <tbody class="mdc-data-table__content">
            {#each teams as team}
              <tr
                class="mdc-data-table__row"
                style="height: 46px"
                on:click={() => open_edit_team_dialog(team.team_id)}>
                <td>{team.name}</td>
                <td>
                  {#if !!team.code}{team.code}{/if}
                </td>
              </tr>
            {/each}
        </tbody>
      </table>
    </div>

    <!-- Hidden dialog add team -->
    <div id="add-team" />

    <!-- Hidden dialog edit team -->
    <div id="edit-team" />

  </main>
<style type="text/scss">
  /* Reset Styles
    *******************************************************/
  * {
    box-sizing: border-box;
    margin: 0;
    /*padding: 0;*/
    text-decoration: none;
  }

  html,
  body,
    /* main { display: flex; flex-direction: column; min-height: 100vh; } */

  main {
    display: flex;
    flex-direction: column;
  }

  section {
  }

  img {
    max-width: 100%;
  }

  input[type='number'] {
    text-align: center;
  }

  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    opacity: 1;
  }

  /* Actual page
    *******************************************************/

  .field_search {
    width: 550px;
    margin-right: 0px;
  }

  /* Table
    **************/

  body {
    font-family: Roboto, sans-serif;
    color: #7a7676;
    line-height: 20px;
    font-size: 16px;
  }

  /*
  th {
    font-weight: 800;
    color: #616161;
    text-align: left;
    font-size: 15px;
  }

  td {
    font-weight: 500;
    color: #616161;
  }

  .mdc-data-table__row {
    border-top-style: dashed;
  }

  table.fitscreen {
    table-layout: fixed;
  }

  .table {
    color: #333;
    width: 100%;
    border: 0;
    border-radius: 0;
    overflow-x: auto;
    margin-top: 10px;
    margin-bottom: 32px;
    background: aliceblue;
  }*/

  .table thead > tr > th,
  .table tbody > tr > th,
  .table tfoot > tr > th,
  .table thead > tr > td,
  .table tbody > tr > td,
  .table tfoot > tr > td {
    padding: 10px;
  }

  .add-button {
    height: 50px;
  }

  .remove-dialog-button {
    height: 20px;
  }

  .dialog-td-emails {
    word-wrap: break-word;
    white-space: normal;
  }

  .mdc-data-table__content tr {
    cursor: pointer;
  }

  .mdc-button--oval {
    border-radius: 40px;
    background-color: var(--mdc-theme-primary);
    color: white;
    height: 48px;
    padding-left: 15px;
    padding-right: 15px;
  }

  /* without a body button hovers

    .mdc-button:hover {
        background: #d1e2f44d;
        border-radius: 7px;
        height: 33px;
    }

    .hover:hover {
        background: #f4d1d14d;
        border-radius: 7px;
        height: 33px;
    }*/

  /* Tooltip
    *******************************************************/

  .tooltip-default {
    position: relative;
    font-size: 12px;
    /*top: -60px;*/
    animation: transition_in 0.6s;
  }

  .tooltip-default .tooltip-top {
    /*position: absolute;*/
    z-index: 1;
    bottom: 100%;
    right: 0;
    left: 50%;
  }

  .tooltip-default .tooltip-text {
    background-color: var(--mdc-theme-secondary);
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 8px 8px;
    display: block;
    padding-left: 30px;
    padding-right: 30px;
    font-size: 13px;
    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.3);
  }

  /*
    .tooltip-default .tooltip-text::after {
        content: " ";
        position: relative;
        top: 30px;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: #018786 transparent transparent transparent;
    } */

  .tooltip-default .tooltip-text::before {
    content: ' ';
    position: relative;
    top: -30px;
    left: 95%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #018786 transparent;
  }

  .fade-in-long {
    animation: transition_in 2.5s;
  }

  .mdc-data-table-bold {
    background-color: blanchedalmond;
  }

  .mdc-data-table__header-cell {
    height: 46px;
  }

  /* Desktop Mode
    *******************************************************/
  @media (min-width: 1025px) {
    .wrapper {
      width: 900px;
      margin: 0 auto;
      margin-bottom: 50px;
      height: fit-content;
      padding: 30px;
    }
  }

  /* Tablet Mode
    *******************************************************/
  @media (min-width: 769px) and (max-width: 1024px) {
    .wrapper {
      width: 90%;
      margin: 0 auto;
      margin-bottom: 50px;
      height: fit-content;
    }
  }

  /* Mobile Mode
    *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    .wrapper {
      /*width: 100%;*/
      margin: 0 auto;
      margin-left: 50px;
      margin-bottom: 50px;
      height: fit-content;
    }

    td {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
</style>
